<ng-template #panelTemplate let-spatialFormVisible>
  <div class="filter-panel">
    @if (!spatialFormVisible) {
      <div class="filter-buttons">
        <tm-create-filter-button></tm-create-filter-button>
        <tm-reset-filters-button></tm-reset-filters-button>
      </div>
    }
    @if (spatialFormVisible) {
      <div class="filter-form">
        <tm-spatial-filter-form></tm-spatial-filter-form>
      </div>
    }
    @if (!spatialFormVisible) {
      <div class="filter-list">
        <tm-filter-list></tm-filter-list>
      </div>
    }
  </div>
</ng-template>

@if (visible$ | async) {
  <ng-container *ngTemplateOutlet="panelTemplate; context: { $implicit: spatialFormVisible$ | async }"></ng-container>
}
